import * as actionType from "../types/ActionTypes";

const initialState = {
  events: [],
  postEvents: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Events = (state = initialState, action) => {
  switch (action.type) {
    case actionType.EVENTS_SET_DATA:
      return {
        ...state,
        events: action.events,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.EVENTS_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.EVENTS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.EVENTS_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.EVENTS_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_EVENTS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_EVENTS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postEvents: action.postEvents,
      };
    case actionType.UPDATE_EVENTS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_EVENTS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_EVENTS_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
